import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';
// import { environment as environmentPromise } from './environments/environment';


// if (environment.production) {
if (true) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));


// environmentPromise()
//   .then((environment: any) => {
//     if (environment["production"]) {
//       enableProdMode();
//     }
//     platformBrowserDynamic().bootstrapModule(AppModule);
//   })
//   .catch((err: any) => { console.log(err) });

